import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f74fc930"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "footer-social" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "footer-social__heading" }, [
  /*#__PURE__*/_createElementVNode("h6", { class: "footer-social__title" }, " ما را در شبکه‌های اجتماعی دنبال نمایید ")
], -1))
const _hoisted_3 = { class: "footer-social__list" }
const _hoisted_4 = ["href"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "17"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    fill: "#FFF",
    d: "M1.311 7.147C6.434 4.879 9.85 3.384 11.559 2.662 16.439.599 17.453.241 18.114.229c.145-.002.47.034.681.208.177.146.415.344.655.483.23.67.52.456.29.703-.93 2.824-2.075 9.675-1.91 12.837-.993 1.338-1.478 1.787-1.948 1.831-1.02.095-1.012-.685-1.892-1.344-2.438-1.03-3.311-1.671-4.813-2.676-1.735-1.162-.61-1.8.379-2.844.259-.273 4.755-4.428 4.842-4.805.011-.048.021-.223-.082-.316-.103-.093.304-.061-.364-.036-.155.036-2.626 1.695-7.412 4.978-.701.489-1.336.728-1.906.715.066-.013-1.834-.36-2.731-.656C.802 8.943.71 8.751.4 8.134c.04-.322.079-.651.911-.987z"
  })
], -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = ["href"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "20"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    fill: "#FFF",
    d: "M21.044 5.364a9.312 9.312 0 0 0 2.339-2.423V2.94a9.723 9.723 0 0 1-2.689.737 4.64 4.64 0 0 0 2.053-2.579 9.348 9.348 0 0 1-2.959 1.13 4.666 4.666 0 0 0-8.074 3.191c0 .37.032.726.108 1.064-3.879-.19-7.313-2.049-9.62-4.882a4.71 4.71 0 0 0-.64 2.359c0 1.616.832 3.049 2.074 3.879a4.618 4.618 0 0 1-2.109-.575v.051a4.69 4.69 0 0 0 3.74 4.587 4.66 4.66 0 0 1-1.224.154c-.299 0-.6-.018-.883-.08.604 1.848 2.321 3.207 4.361 3.252a9.39 9.39 0 0 1-5.788 1.99c-.382 0-.749-.017-1.117-.064a13.145 13.145 0 0 0 7.161 2.095c8.236 0 13.604-6.872 13.267-13.885z"
  })
], -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = ["href"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "22",
  height: "21"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    fill: "#FFF",
    d: "M20.925 14.816c-.143 3.123-1.61 4.863-3.554 5.618-1.43.554-2.825.551-6.868.551-3.941 0-6.7.266-8.726-1.762-1.987-1.989-1.76-4.648-1.76-8.734 0-3.992-.258-6.714 1.76-8.734C2.985.546 4.483.136 6.181.056c1.932-.086 6.714-.09 8.645 0 3.949.182 5.926 2.419 6.099 6.106.086 1.934.091 6.72 0 8.654zM19.1 10.488c0-2.802-.011-3.135-.061-4.242-.219-4.852-3.875-4.364-8.534-4.364l-.04-.026c-2.804 0-3.132.013-4.246.052-4.848.249-4.352 3.731-4.352 8.567 0 3.574-.267 5.931 1.206 7.399 1.279 1.284 3.033 1.219 7.404 1.219 4.246 0 6.082.118 7.405-1.206 1.3-1.308 1.217-3.073 1.218-7.399zm-2.999-4.342a1.26 1.26 0 1 1 0-2.519 1.26 1.26 0 0 1 0 2.519zm-5.598 9.733a5.387 5.387 0 0 1-5.385-5.39 5.386 5.386 0 1 1 10.769 0 5.387 5.387 0 0 1-5.384 5.39zm0-8.888a3.496 3.496 0 0 0-3.495 3.498 3.496 3.496 0 1 0 6.99 0 3.497 3.497 0 0 0-3.495-3.498z"
  })
], -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = ["href"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "21",
  height: "21"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    fill: "#FFF",
    d: "M20.37 20.124v.001h-4.034v-6.339c0-1.51-.031-3.447-2.102-3.447-2.102 0-2.424 1.641-2.424 3.338v6.447H7.772V7.105h3.878v1.776h.057c.539-1.023 1.858-2.102 3.824-2.102 4.091 0 4.844 2.695 4.844 6.193v7.152h-.005zM3.217 5.33C1.924 5.33.875 4.259.875 2.966a2.342 2.342 0 0 1 4.683 0c0 1.293-1.049 2.364-2.341 2.364zM5.24 20.125H1.197V7.106H5.24v13.019z"
  })
], -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = ["href"]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "22",
  height: "16"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    fill: "#FFF",
    d: "m21.513 2.286.028.184c-.266-.968-.984-1.716-1.896-1.988l-.019-.004C17.911 0 11.009 0 11.009 0S4.125-.01 2.393.478A2.828 2.828 0 0 0 .483 2.45l-.004.02c-.641 3.436-.646 7.565.028 11.244l-.028-.186c.265.969.983 1.716 1.895 1.988l.02.005C4.107 16 11.01 16 11.01 16s6.883 0 8.616-.479a2.828 2.828 0 0 0 1.911-1.973l.004-.02A30.14 30.14 0 0 0 22 8.212l-.001-.208.001-.216c0-1.88-.167-3.719-.487-5.502zm-12.706 9.15V4.572l5.744 3.437-5.744 3.427z"
  })
], -1))
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = ["href"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "22",
  height: "22"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    fill: "#FFF",
    d: "m21.875 8.168-.923 3.875c1.087-4.567-1.726-9.202-6.251-10.3l3.839.931c2.414.586 3.915 3.058 3.335 5.494zM1.664 7.366l.923-3.875C3.167 1.055 5.616-.459 8.03.126l3.839.931C7.344-.04 2.752 2.798 1.664 7.366zM11 1.237c5.343 0 9.674 4.371 9.674 9.763 0 5.392-4.331 9.763-9.674 9.763-5.343 0-9.674-4.371-9.674-9.763 0-5.392 4.331-9.763 9.674-9.763zM8.263 3.9c-1.511 0-2.737 1.237-2.737 2.762 0 1.526 1.226 2.762 2.737 2.762C9.775 9.424 11 8.188 11 6.662 11 5.137 9.775 3.9 8.263 3.9zm9.656 4.133c0-1.526-1.225-2.762-2.736-2.762-1.512 0-2.737 1.236-2.737 2.762 0 1.525 1.225 2.762 2.737 2.762 1.511 0 2.736-1.237 2.736-2.762zm-4.196 10.111c1.511 0 2.736-1.237 2.736-2.762s-1.225-2.762-2.736-2.762c-1.512 0-2.737 1.237-2.737 2.762s1.225 2.762 2.737 2.762zm-2.793-5.833c.664 0 1.202-.543 1.202-1.213s-.538-1.213-1.202-1.213c-.664 0-1.202.543-1.202 1.213s.538 1.213 1.202 1.213zm-4.127 4.463c1.512 0 2.737-1.237 2.737-2.762 0-1.526-1.225-2.762-2.737-2.762-1.511 0-2.737 1.236-2.737 2.762 0 1.525 1.226 2.762 2.737 2.762zm.496 3.482h-.001l-3.839-.931C1.045 18.74-.455 16.268.125 13.831l.922-3.874c-1.087 4.567 1.726 9.202 6.252 10.299zm13.036-5.623-.922 3.875c-.58 2.437-3.03 3.951-5.444 3.366l-3.839-.931c4.526 1.097 9.118-1.742 10.205-6.31z"
  })
], -1))
const _hoisted_21 = [
  _hoisted_20
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("ul", _hoisted_3, [
      _createElementVNode("li", null, [
        _createElementVNode("a", {
          href: _ctx.SOCIAL.TELEGRAM,
          target: "_blank",
          class: "footer-social__link"
        }, _hoisted_6, 8, _hoisted_4)
      ]),
      _createElementVNode("li", null, [
        _createElementVNode("a", {
          href: _ctx.SOCIAL.TWITTER,
          target: "_blank",
          class: "footer-social__link"
        }, _hoisted_9, 8, _hoisted_7)
      ]),
      _createElementVNode("li", null, [
        _createElementVNode("a", {
          href: _ctx.SOCIAL.INSTAGRAM,
          target: "_blank",
          class: "footer-social__link"
        }, _hoisted_12, 8, _hoisted_10)
      ]),
      _createElementVNode("li", null, [
        _createElementVNode("a", {
          href: _ctx.SOCIAL.LINKEDIN,
          target: "_blank",
          class: "footer-social__link"
        }, _hoisted_15, 8, _hoisted_13)
      ]),
      _createElementVNode("li", null, [
        _createElementVNode("a", {
          href: _ctx.SOCIAL.YOUTUBE,
          target: "_blank",
          class: "footer-social__link"
        }, _hoisted_18, 8, _hoisted_16)
      ]),
      _createElementVNode("li", null, [
        _createElementVNode("a", {
          href: _ctx.SOCIAL.APARAT,
          target: "_blank",
          class: "footer-social__link"
        }, _hoisted_21, 8, _hoisted_19)
      ])
    ])
  ]))
}